export default __webpack_public_path__ + "static/media/trio.45df5feb.png";